// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form.statute-form {
  padding-top: 15px;
  margin: 15px 0;
  border-bottom: 1px solid #e2e2e2;
  border-top: 1px solid #e2e2e2;
  background-color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/app/crimgrid-module/components/statute-manager/statute-manager.component.less"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,cAAA;EACA,gCAAA;EACA,6BAAA;EACA,sBAAA;AACJ","sourcesContent":["form.statute-form{\n    padding-top: 15px;\n    margin: 15px 0;\n    border-bottom: 1px solid #e2e2e2;\n    border-top: 1px solid #e2e2e2;\n    background-color: #fff;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
